import * as React from "react";
import { FieldProps } from "./props";
import "./autocomplete.scss";
import {
  ActivityTypes,
  convertPascalCaseToWords,
  DateFormats,
  getMinutes,
  ILeadActivity,
  State,
} from "../../../core";
import { isObject } from "util";
import moment from "moment";
import { EditEventPopup } from "../../../containers/leads/components/activities/edit-event-popup";
import { useAppSettings } from "../../../core/hooks/useAppSettings";
import api from "../../../api";
import { combineDateAndTime } from "../../../utils/CombineDateAndTime";
import { AddNoteActivity } from "../../../containers/leads/components/activities/add-note-activity";
import { useSelector } from "react-redux";

const ActivityAutoCompleteInput: React.FunctionComponent<FieldProps> = (
  props
) => {
  const authState = useSelector((state: State) => state.authUser);
  const appSettings = useAppSettings(api.settings);
  const [list, setList] = React.useState<ILeadActivity[]>();
  const [isLoaded, setIsLoaded] = React.useState<boolean>(false);
  const [showDropDown, setShowDropDown] = React.useState<boolean>(false);
  const [selectedItem, setSelectedItem] = React.useState<
    ILeadActivity | undefined
  >(props.defaultValue || undefined);
  const [isActivity, setAddActivity] = React.useState(false);

  const wrapperRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (!isLoaded) {
      loadData("");
    }
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  React.useEffect(() => {
    if (!isLoaded) {
      loadData("");
    }
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  React.useEffect(() => {
    const id = isObject(props.defaultValue)
      ? props.defaultValue?._id
      : props.defaultValue;
    if (id && id !== selectedItem?._id) {
      setSelectedItem(list?.find((x) => x._id === id));
    }
    if (
      id &&
      id !== selectedItem?._id &&
      !list?.find((x) => x._id === id) &&
      isObject(props.defaultValue)
    ) {
      setSelectedItem(props.defaultValue);
    }
  }, [props.defaultValue]);

  React.useEffect(() => {
    setList([]);
    const filteredList =
      props.type === "note"
        ? list?.filter((x) => x.type === "note")
        : list?.filter((x) => x.type !== "note");

    setList(filteredList);
  }, [props.type]);

  const loadData = async (query: string) => {
    setIsLoaded(false);
    const filter: any = {
      query,
      showroomId: props.showroomId,
      page: 1,
      perPage: 25,
    };

    if (props.hideBlocked) {
      filter.hideBlocked = true;
    }

    let response = await props.dataLoader?.(query);

    response =
      props.type === "note"
        ? response?.filter((x) => x.type === "note")
        : response?.filter((x) => x.type !== "note");

    setList(response);
    setIsLoaded(true);
  };

  const clickDropDown = () => {
    if (props.disabled) {
      return;
    }
    loadData("");
    setShowDropDown(!showDropDown);
  };

  const handleChange = (e: { target: any }) => {
    const { value } = e.target;

    loadData(value);
  };

  const handleSelect = (item: ILeadActivity) => {
    setList([item]);
    setSelectedItem(item);
    setShowDropDown(false);

    if (props.onChange != null) {
      props.onChange(item);
    }
  };

  const handleClickOutside = (event: { target: any }) => {
    if (
      wrapperRef &&
      wrapperRef.current &&
      !wrapperRef.current.contains(event.target)
    ) {
      setShowDropDown(false);
    }
  };

  const minimumDurationInMinutes = getMinutes(
    appSettings?.data?.activity?.activityMinimumDuration || {
      value: 15,
      unit: "Minutes",
    }
  );

  const startDateTime = combineDateAndTime(
    moment().startOf("day").toDate(),
    appSettings?.data?.application?.appointmentTime?.start || "9:30 AM"
  );

  return (
    <React.Fragment>
      {props.label && <label className={props.labelClass}>{props.label}</label>}
      <div className="custom-dropdown position-relative" ref={wrapperRef}>
        <div
          onClick={clickDropDown}
          className="custom-dropdown__value bg-gray-100 border rounded-sm font-normal d-flex align-items-center font-weight-semibold cursor-pointer"
        >
          {selectedItem && props.defaultValue ? (
            <div
              className="flex-fill text-truncate custom-dropdown__value-text"
              dangerouslySetInnerHTML={{
                __html:
                  selectedItem.type === ActivityTypes.Note
                    ? selectedItem.note
                    : selectedItem.title,
              }}
            ></div>
          ) : (
            <div className="flex-fill text-truncate custom-dropdown__value-text">
              Select
            </div>
          )}

          {(!selectedItem || !props.defaultValue || !props.onReset) && (
            <i className="icon-chevron-down ml-auto"></i>
          )}
          {selectedItem && props.defaultValue && props.onReset && (
            <i
              onClick={() => {
                setSelectedItem(undefined);
                props.onReset?.();
              }}
              className="icon-close ml-auto"
            ></i>
          )}
        </div>
        {showDropDown && !props.disabled && (
          <div className="custom-dropdown__menu custom-dropdown__menu--open border overflow-auto w-100 position-absolute left-0 bg-white zIndex-9 pt-0">
            {isLoaded ? (
              <>
                {!list?.length && (
                  <div className="align-items-center border-bottom cursor-pointer custom-dropdown__menu-item font-sm pb-0 text-center">
                    No Data
                  </div>
                )}
                {list?.map((item) => {
                  return (
                    <div
                      onClick={() => handleSelect(item)}
                      className="custom-dropdown__menu-item border-bottom d-flex align-items-center cursor-pointer"
                    >
                      <div className="col gutter-10 pr-0 row sales-person align-items-center">
                        <div className="col-xl-12 col-12 pl-0 d-flex align-items-center">
                          <>
                            <div
                              className="truncate d-inline-block font-normal font-weight-semibold"
                              style={{ width: "300px" }}
                            >
                              <h6
                                className="font-weight-semibold mb-2 font-xs"
                                dangerouslySetInnerHTML={{
                                  __html:
                                    item.type === ActivityTypes.Note
                                      ? item.note
                                      : item.title,
                                }}
                              ></h6>
                            </div>
                          </>
                        </div>
                        <div className="w-100 font-xs">
                          <span className="text-muted font-weight-semibold">
                            {moment(item?.startDate || item?.createdAt).format(
                              "DD MMM YYYY hh:mm A"
                            )}
                          </span>
                          <span
                            style={{ height: "4px", width: "4px" }}
                            className="activity-separator d-inline-block bg-gray-400 rounded-circle mx-2"
                          ></span>
                          {item.type !== "note" ? (
                            <>
                              <span className="text-muted font-weight-semibold">
                                {convertPascalCaseToWords(item.type)}
                              </span>
                              <span
                                style={{ height: "4px", width: "4px" }}
                                className="activity-separator d-inline-block bg-gray-400 rounded-circle mx-2"
                              ></span>
                              <span className="text-muted font-weight-semibold pl-2">
                                <span className="mr-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="14"
                                    height="14"
                                    viewBox="0 0 14 14"
                                    fill="none"
                                  >
                                    <rect
                                      width="14"
                                      height="14"
                                      rx="7"
                                      fill={
                                        item?.status === "planned"
                                          ? "#B8B8B8"
                                          : "#27AE60"
                                      }
                                    />
                                    <path
                                      d="M4 7.24219L5.9799 9.22209C6.058 9.30019 6.18464 9.30019 6.26274 9.22209L10.364 5.12087"
                                      stroke="white"
                                      stroke-linecap="round"
                                    />
                                  </svg>
                                </span>{" "}
                                {convertPascalCaseToWords(item.status)}{" "}
                              </span>
                            </>
                          ) : (
                            <>
                              <span className="text-muted font-weight-semibold">
                                {item?.createdBy?.name}
                              </span>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
                <div className="custom-dropdown__menu-item align-items-center cursor-pointer py-1">
                  <div className="col-md-auto col-12 mt-1 p-0">
                    <span
                      onClick={() => {
                        setAddActivity(true);
                        setShowDropDown(false);
                      }}
                      className="font-normal font-weight-semibold py-2 px-2 h-100 cursor-pointer text-primary d-flex align-items-center"
                    >
                      <i
                        className="font-xxs icon-plus mr-2 p-1 rounded-circle text-primary border border-primary border-width-2 font-weight-bold"
                        style={{ border: "2px solid #4161c8 !important" }}
                      ></i>{" "}
                      {props.type !== "note"
                        ? "Add New Activity"
                        : "Add New Note"}
                    </span>
                  </div>
                </div>
              </>
            ) : (
              <div className="align-items-center border-bottom cursor-pointer custom-dropdown__menu-item font-sm pb-0 text-center">
                Loading...
              </div>
            )}
          </div>
        )}
        {isActivity && props.type !== "note" && (
          <EditEventPopup
            action={{
              name: "Create Activity",
              code: "call",
              _id: "call",
            }}
            isEdit={false}
            currentActivity={{
              type: "call",
              title: "",
              timePeriod: {
                startDate: new Date(),
                startTime:
                  appSettings?.data?.application?.appointmentTime?.start ||
                  "9:00 AM",
                endTime:
                  moment(startDateTime)
                    .add(minimumDurationInMinutes, "minute")
                    .format(DateFormats.TimeOnlyFormat) || "9:30 AM",
              },
              showRoom: props?.leadDetails?.showroom
                ? {
                    _id: props?.leadDetails?.showroom?._id || "",
                    title: props?.leadDetails?.showroom?.title,
                  }
                : undefined,
              salesPerson: authState?.profile
                ? {
                    _id: authState?.profile?._id || "",
                    name: authState?.profile?.name,
                    knownAs: authState?.profile?.knownAs,
                  }
                : undefined,
              busyEvent: true,
              company : props?.leadDetails?.company
            }}
            onClose={() => {
              setAddActivity(false);
            }}
            onSubmit={(updatedEvent) => {
              loadData("");
              setShowDropDown(false);
            }}
            onSubmitCompleted={() => {
              loadData("");
              setShowDropDown(false);
              setAddActivity(false);
            }}
            leadId={props?.leadDetails?._id!}
            loadCurrentTime
            // customerId={props?.leadDetails?.customer?._id!}
            // companyId={props?.leadDetails?.company?._id!}
          ></EditEventPopup>
        )}
      </div>
      {isActivity && props.type === "note" && (
        <AddNoteActivity
          leadId={props?.leadDetails?._id!}
          onSubmitCompleted={() => {
            loadData("");
            setShowDropDown(false);
            setAddActivity(false);
          }}
          showForm={true}
        ></AddNoteActivity>
      )}
    </React.Fragment>
  );
};

export default ActivityAutoCompleteInput;
